import React from "react"
import WelcomeBanner from "."
import PropTypes from "prop-types"

class WelcomeBannerControlled extends React.Component {
  constructor(props) {
    super(props)

    if (props.reset) {
      localStorage.setItem("welcomeBannerClosed", "false")
    }

    this.state = {
      closed: localStorage.getItem("welcomeBannerClosed") === "true",
    }
  }

  onClose = () => {
    localStorage.setItem("welcomeBannerClosed", "true")
    this.setState({ closed: true })
  }

  render() {
    if (this.state.closed) {
      return null
    } else {
      return <WelcomeBanner onClose={this.onClose} />
    }
  }
}

WelcomeBannerControlled.defaultProps = {
  reset: false,
}

WelcomeBannerControlled.propTypes = {
  reset: PropTypes.bool,
}

export default WelcomeBannerControlled
